"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.profanity = void 0;
exports.profanity = [
    'arse',
    'ass',
    'asshole',
    'bastard',
    'bitch',
    'boong',
    'cock',
    'cocksucker',
    'coon',
    'coonass',
    'crap',
    'cunt',
    'damn',
    'darn',
    'douche',
    'fag',
    'faggot',
    'fuck',
    'gook',
    'motherfucker',
    'piss',
    'pussy',
    'shit',
    'slut',
    'tits',
    'motherfucker',
    'cocksucker',
];
